module.exports = __webpack_public_path__ + "img/1.98b900ca.jpg";